import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { EditorModule } from '@tinymce/tinymce-angular';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizedKeyValue } from '@shared/models/dataref.model';
import { NgForOf, NgIf } from '@angular/common';
import { CommentSearchContent } from '@shared/models/search.model';
import { MatSelectModule } from '@angular/material/select';

export interface RejectCommentDialogData {
  comments: CommentSearchContent[];
  commentReasons: LocalizedKeyValue[];
  market: string;
  lang: string;
}

interface RejectCommentForm {
  reason: string;
}

@Component({
  selector: 'app-reject-comment-dialog',
  templateUrl: './reject-comment-dialog.component.html',
  styleUrls: ['./reject-comment-dialog.component.scss'],
  imports: [
    MatDialogModule,
    MatButtonModule,
    EditorModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    TranslateModule,
    NgForOf,
    NgIf,
  ],
})
export class RejectCommentDialogComponent implements OnInit {
  rejectCommentForm: FormGroup = this.formBuilder.group<RejectCommentForm>({
    reason: '',
  });
  reasons: { key: string; value: string }[] = [];

  constructor(
    public dialogRef: MatDialogRef<RejectCommentDialogComponent, string | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: RejectCommentDialogData,
    private readonly formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.reasons = this.data.commentReasons
      .map((reason) => {
        const reasonName = reason.name;
        return {
          key: reason.key,
          value: reasonName[this.data.market]?.[this.data.lang] || '',
        };
      })
      .filter((reason) => reason.value);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  rejectComments(): void {
    const reasonControl = this.rejectCommentForm.get('reason') as FormControl;
    this.dialogRef.close(reasonControl.value);
  }
}
